
import wixWindow from 'wix-window';
$w.onReady(function () {
  let myLang = wixWindow.multilingual.currentLanguage; 
  if (myLang === 'en') {
    $w('#horizontalMenu1').hide();
    $w('#languageSelector17').show();
     $w('#languageSelector19').hide();
    $w('#horizontalMenu2').show();
    $w('#image45').show();
    $w('#button19').show();
    $w('#button22').hide();
  } else {
    $w('#horizontalMenu2').hide();
    $w('#horizontalMenu1').show();
    $w('#image10').show();
    $w('#languageSelector19').show();
    $w('#languageSelector17').hide();
    $w('#button19').hide();
    $w('#button22').show();
  }
});